import React from 'react';
// eslint-disable-next-line no-restricted-imports
import ThreadsToggleSwitch, { Props } from 'plaid-threads/ToggleSwitch';

const ToggleSwitch: React.FC<Props> = (props) => {
  return <ThreadsToggleSwitch {...props} />;
};

export default ToggleSwitch;
